namespace GeniuzPOS.Inventory {
    export interface IcStockCountCodeForm {
        SysDocNo: Serenity.StringEditor;
        StockCountCode: Serenity.StringEditor;
        StockCountDesc: Serenity.StringEditor;
        StockCountDate: Serenity.DateEditor;
        RefDocNo: Serenity.StringEditor;
        WhsId: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        ApproveFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        IcStockCountTranList: IcStockCountTranEditor;
    }

    export class IcStockCountCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockCountCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockCountCodeForm.init)  {
                IcStockCountCodeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.TextAreaEditor;
                var w5 = IcStockCountTranEditor;

                Q.initFormType(IcStockCountCodeForm, [
                    'SysDocNo', w0,
                    'StockCountCode', w0,
                    'StockCountDesc', w0,
                    'StockCountDate', w1,
                    'RefDocNo', w0,
                    'WhsId', w2,
                    'PostFg', w3,
                    'CancelFg', w3,
                    'ApproveFg', w3,
                    'Remark', w4,
                    'IcStockCountTranList', w5
                ]);
            }
        }
    }
}
